export default __webpack_public_path__ + "static/media/ic-art-new-born.2c111078.svg";